module.exports = __webpack_public_path__ + "static/media/053.3f68fb70.jpg";